// Web version is a no-op
function RefetchDataSourceController() {
  return null;
}

export default RefetchDataSourceController;
